import { render, staticRenderFns } from "./productDetailView.vue?vue&type=template&id=0c89f7cb&scoped=true"
import script from "./productDetailView.vue?vue&type=script&lang=js"
export * from "./productDetailView.vue?vue&type=script&lang=js"
import style0 from "./productDetailView.vue?vue&type=style&index=0&id=0c89f7cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89f7cb",
  null
  
)

export default component.exports